
export default function ContentIcon() {
  return (
    <svg
      width="26"
      height="30"
      viewBox="0 0 27 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.75"
        y="32.5542"
        width="23.5"
        height="5.25245"
        rx="2.25"
        stroke="black"
        stroke-width="1.5"
      />
      <path
        d="M7 32.2863L1.5 18.2991L14 1.41797L26 18.2991L20.5 32.2863"
        stroke="black"
        stroke-width="1.5"
      />
      <path d="M14 15.8866V1.89941" stroke="black" stroke-width="1.5" />
      <path
        d="M17.25 19.2643C17.25 20.9559 15.8206 22.3728 14 22.3728C12.1794 22.3728 10.75 20.9559 10.75 19.2643C10.75 17.5727 12.1794 16.1558 14 16.1558C15.8206 16.1558 17.25 17.5727 17.25 19.2643Z"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
}
